import Vue from "vue";
import { editController } from "../edit";
import { sonbpIFContoroller } from "./edit.sonbp_if";


/**
 * 編集画面関連の基底クラス
 */
export abstract class BaseLogicClass {

// #region ■定数・変数

    protected _vue: Vue;                                // Vue.jsオブジェクト
    protected sonbpIfController: sonbpIFContoroller;    // sonbpIF関連操作
    protected _usePcDesign: boolean;                    // PCサイト？
    protected _authToken: string;                       // 認証トークン

    /**
     * TODO 
     * 相互参照は不本意だが、editController内の状態・メソッドを共有が必要のためやむなし・・・。
     * できれば、最終的には削除したい。。
     */
    protected _edctrl: editController;

// #endregion

// #region ■起動

    /**
     * コンストラクタ
     */
    constructor(edctrl: editController) {
        this._edctrl = edctrl;
    }

    /**
     * 初期化
     */
    public init(v: Vue, sonbpIf: sonbpIFContoroller, usePcDesign: boolean, authToken: string) {
        this._vue = v;
        this.sonbpIfController = sonbpIf;
        this._usePcDesign = usePcDesign;
        this._authToken = authToken;
    }

// #endregion

// #region ■イベント
// #endregion

// #region ■内部関数

    /**
     * 可視設定フラグを一旦全てOFFにする(SP用)
     */
    protected setShowFlgAllOFF() {

        if (this._usePcDesign) {
            //PC

            // パネルの表示制御
            this._vue.$data.Show.BalloonGuidance = false;
            this._vue.$data.Show.PhotoList = false;
            this._vue.$data.Show.OparatePallet = false;
            this._vue.$data.Show.GreetingPanel = false;
            this._vue.$data.Show.SenderPanel = false;
            this._vue.$data.Show.StampPanel = false;
            this._vue.$data.Show.MyStampPanel = false;
            this._vue.$data.Show.TegakiStampPanel = false;


            // ツールメニューの活性制御
            this._vue.$data.ActiveSetPhotoMenu = false;
            this._vue.$data.ActiveManiPhotoMenu = false;
            this._vue.$data.ActiveGreetingMenu = false;
            this._vue.$data.ActiveSenderMenu = false;
            this._vue.$data.ActiveStampMenu = false;
            this._vue.$data.ActiveMyStampMenu = false;
            this._vue.$data.ActiveTegakiStampMenu = false;
            this._vue.$data.ActiveFinishSelectMenu = false;

        } else {
            //SP

            // ヘッダーメニュー
            this._vue.$data.Show.ReturnFlowBtn = false;
            this._vue.$data.Show.ReturnHomeBtn = false;
            this._vue.$data.Show.ReturnHomeExBtn = false;
            this._vue.$data.Show.ReturnStampHomeBtn = false;
            this._vue.$data.Show.ReturnMyStampHomeBtn = false;
            this._vue.$data.Show.ReturnTegakiStampHomeBtn = false;
            this._vue.$data.Show.NextFlowBtn = false;
            this._vue.$data.Show.NextHomeFromImgListBtn = false;
            this._vue.$data.Show.NextHomeFromMyStampListBtn = false;
            this._vue.$data.Show.NextHomeFromTegakiStampListBtn = false;

            // メインメニュー
            this._vue.$data.Show.CommitNextHomeBtn = false;
            this._vue.$data.Show.StampDeleteBtn = false;
            this._vue.$data.Show.MyStampListTrashBtn = false;
            this._vue.$data.Show.TegakiStampListTrashBtn = false;

            // 編集パネル
            this._vue.$data.Show.GreetingPanel = false;
            this._vue.$data.Show.SenderPanel = false;
            this._vue.$data.Show.StampPanel = false;
            this._vue.$data.Show.MyStampPanel = false;
            this._vue.$data.Show.TegakiStampPanel = false;
            this._vue.$data.Show.TegakiColorPanel = false;

            // 編集エリア
            this._vue.$data.Show.EditArea = false;
            this._vue.$data.Show.PhotoList = false;
            this._vue.$data.Show.MyStampList = false;
            this._vue.$data.Show.TegakiStampList = false;

            // フッターメニュー
            this._vue.$data.Show.FooterMenu = false;
            this._vue.$data.Show.SetPhotoMenu = false;
            this._vue.$data.Show.SetMyStampMenu = false;
            this._vue.$data.Show.EditImageMenu = false;
            this._vue.$data.Show.OparatePallet = false;
        }
    }

// #endregion

}
